import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const fetchNotificationsForTeam = async (teamId, token, unreadOnly = false) => {
  const url = unreadOnly 
    ? `${API_URL}/notifications/team/${teamId}?unreadOnly=true`
    : `${API_URL}/notifications/team/${teamId}`;
    
  const response = await fetch(url, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente varsler.');
};

export const markNotificationAsRead = async (notificationId, token) => {
  const response = await fetch(`${API_URL}/notifications/${notificationId}/read`, {
    method: 'PUT',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke markere varsel som lest.');
};

export const markAllAsReadForTeam = async (teamId, token) => {
  const response = await fetch(`${API_URL}/notifications/team/${teamId}/read-all`, {
    method: 'PUT',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke markere alle varsler som lest.');
};

export const fetchMyNotifications = async (token, unreadOnly = false) => {
  const url = unreadOnly
    ? `${API_URL}/notifications/user?unreadOnly=true`
    : `${API_URL}/notifications/user`;

  const response = await fetch(url, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente varsler.');
};

export const fetchUnreadCountForUser = async (token) => {
  const response = await fetch(`${API_URL}/notifications/unread-count`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente antall uleste varsler.');
};

export const deleteNotification = async (notificationId, token) => {
  const response = await fetch(`${API_URL}/notifications/${notificationId}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette varsel.');
};

export const deleteAllNotifications = async (token) => {
  const response = await fetch(`${API_URL}/notifications`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette alle varsler.');
};
